var map = {
	"./base.yaml": 89589,
	"./offer-v1.yaml": 27912,
	"./order-v1.yaml": 11786,
	"./platform-v1.yaml": 94729,
	"./product-v1.yaml": 54091,
	"./workflow-v1.yaml": 52091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8565;